import { css } from "@emotion/css";
import React from "react";
import * as RadixSwitch from "@radix-ui/react-switch";
import { theme } from "assets/theme";

type Props = {
  selected?: boolean;
  onSelected?(value: boolean): void;
  label?: string;
  defaultChecked?: boolean;
  disabled?: boolean;
};
export const Switch: React.FC<Props> = ({
  selected,
  defaultChecked,
  label,
  disabled,
  onSelected,
}) => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {label && (
        <label
          className="Label"
          htmlFor="airplane-mode"
          style={{ paddingRight: 15 }}
        >
          {label}
        </label>
      )}
      <RadixSwitch.Root
        checked={selected}
        defaultChecked={defaultChecked}
        onCheckedChange={onSelected}
        disabled={disabled}
        className={css`
          width: 64px;
          height: 30px;
          background-color: ${theme.colors.background.secondary};
          border: 1px solid ${theme.colors.border.primary};
          border-radius: 9999px;
          position: relative;
          box-shadow: 0 2px 10px #00000029;
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
          cursor: pointer;
          &:focus {
            box-shadow: 0 0 0 2px black;
          }
          &[data-state="checked"] {
            background-color: ${theme.colors.text["highlight/3"]};
          }
          &[data-disabled] {
            cursor: not-allowed;
            opacity: 0.5;
          }
        `}
        id="airplane-mode"
      >
        <RadixSwitch.Thumb
          className={css`
            display: block;
            width: 21px;
            height: 21px;
            background-color: white;
            border-radius: 9999px;
            box-shadow: 0 2px 2px #00000029;
            transition: transform 100ms;
            transform: translateX(2px);
            will-change: transform;
            &[data-state="checked"] {
              transform: translateX(40px);
            }
          `}
        />
      </RadixSwitch.Root>
    </div>
  );
};
